import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import Panel from '../Panel';

class LoadingPanel extends Component {
  render() {
    return (
      <Panel
        title="POP Users"
        avatar={(
          <Avatar>
            <Lock />
          </Avatar>
)}
      >
        <Table>
          <TableBody>
            {Array(this.props.rows)
              .fill(null)
              .map((val, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <Skeleton />
                  </TableCell>
                  <TableCell>
                    <Skeleton />
                  </TableCell>
                  <TableCell>
                    <Skeleton />
                  </TableCell>
                  <TableCell>
                    <Skeleton />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Panel>
    );
  }
}

LoadingPanel.propTypes = {
  rows: PropTypes.number.isRequired,
};

export default LoadingPanel;
